<template>
  <el-container id="data">
    <el-header
        style="display:flex;height:0.5vh;align-items:center;padding:0;margin:0;background:#F4F4F4">
      <!--      <div v-for="l in li_h_text" :class="l.bj"-->
      <!--           :style="{width:'35%',height:'10vh',display:'flex',marginLeft:'15px',alignItems:'center'}">-->
      <!--        <el-image :src="l.img" style="color:#FBFCFE;width:48px;height:48px;margin-left:2vw"></el-image>-->
      <!--        <div style="height:80px;line-height:0.3;margin-left:16px">-->
      <!--          <p style="height:10px;color: #B0B0B2">{{ l.text }}</p>-->
      <!--          <p style="text-align:left">{{ l.sum }} {{ l.dw }}</p>-->
      <!--        </div>-->
      <!--        <div style="display:flex;align-items:flex-end;height:6vh;margin-left:auto;margin-right:2vw">-->
      <!--          <p style="height:10px;">{{ l.text1 }}</p>-->
      <!--          <p style="height:10px;text-align:left;margin-left:5px">{{ l.sum1 }} {{ l.dw1 }}</p>-->
      <!--          <p style="height:10px;margin-left:15px">{{ l.text2 }}</p>-->
      <!--          <p style="height:10px;text-align:left;margin-left:5px">{{ l.sum2 }} {{ l.dw2 }}</p>-->
      <!--        </div>-->
      <!--      </div>-->
    </el-header>
    <el-container class="div_main" style="height:100%;margin-left:15px;">
      <el-header style="display:flex;align-items:center;height:60px;line-height:30px;background: #FFFFFF">
        <div style="width:75%;display:flex;">
          <p style="height:10px;margin-left:30px;color:#000000;font-size:18px;font-weight:bolder">能耗分析</p>
          <p style="margin-left:auto" @click="onRq(0)" :class="{data_active:item_xz === 0}">今日</p>
          <p style="margin-left:20px" @click="onRq(1)" :class="{data_active:item_xz === 1}">本周</p>
          <p style="margin-left:20px" @click="onRq(2)" :class="{data_active:item_xz === 2}">本月</p>
          <p style="margin-left:20px;margin-right:15px" @click="onRq(3)" :class="{data_active:item_xz === 3}">本年</p>
        </div>
        <!--        <el-date-picker
                  v-model="xz_date"
                  @change="upDate"
                  size="small"
                  style="width:20%;margin-left:15px"
                  type="daterange"
                  format="yyyy-MM-dd"
                  :clearable="false"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>-->
      </el-header>
      <el-divider direction="horizontal" style="width:100%"></el-divider>
      <el-main style="display:flex;background: #FFFFFF">
        <div style="width:75%;">
          <div style="height:100%;background-color:#FFFFFF;border-radius:3px;border:10px;box-shadow: 0 0 5px #3a8ee6;">
            <div id="myChart" style="width:100%; height:100%;margin-bottom:0px"> <!--曲线图-->
            </div>
          </div>
        </div>
        <div style="width:25%;height:100%;margin-right:10px;">
          <div v-for="l in li_right" :class="l.bj"
               style="height:18vh;margin-top:5px;display:flex;align-items:flex-start;">
            <el-image :src="l.img"
                      style="color:#FBFCFE;width:40px;height:40px;margin-left:2vw;padding-top:40px"></el-image>
            <p style="width:auto;height:48px;padding-top:35px;margin-left:10px;color:#000000">{{ l.text }}</p>
            <div style="height:auto;width:auto;line-height:0.3;margin-left:auto;margin-right:40px;margin-top:18%">
              <p v-if="l.sum" style="font-size:17px;">
                约 {{ l.sum }} {{ l.dw }}</p>
              <p v-else style="font-size:17px"> {{ l.sum }} {{ l.dw }}</p>
              <p style="font-size:25px">{{ l.sum1 }} {{ l.dw1 }}</p>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import '../assets/css/icon_data.css';
import moment from "moment/moment";

export default {
  name:"data",
  data() {
    return {
      item_xz:0,
      nh_save:[],
      nh_consume:[],
      nh_mDate:[],
      li_h_text:[
        {
          "text":"设备数量",
          "sum":"15",
          "dw":"个",
          "text1":"空调",
          "sum1":"15",
          "dw1":"个",
          "text2":"网关",
          "sum2":"15",
          "dw2":"个",
          "img":require('@/assets/device1.png'),
          "bj":"data_1"
        },
        {
          "text":"正常运行",
          "sum":"15",
          "dw":"个",
          "text1":"周同比",
          "sum1":"15",
          "dw1":"%",
          "text2":"日环比",
          "sum2":"15",
          "dw2":"%",
          "img":require('@/assets/normal.png'),
          "bj":"data_2"
        },
        {
          "text":"节能策略总执行",
          "sum":"15",
          "dw":"次",
          "text1":"周执行",
          "sum1":"15",
          "dw1":"次",
          "text2":"日执行",
          "sum2":"15",
          "dw2":"次",
          "img":require('@/assets/replace.png'),
          "bj":"data_3"
        }
      ],
      li_right:[
        {
          "text":"已耗电",
          "sum":"15",
          "dw":"瓦",
          "sum1":"15",
          "dw1":"元",
          "img":require('@/assets/consume_power.png'),
          "bj":"data_5"
        },
        {
          "text":"已节省",
          "sum":"15",
          "dw":"瓦",
          "sum1":"15",
          "dw1":"元",
          "img":require('@/assets/save.png'),
          "bj":"data_5"
        },
        {
          "text":"节能率",
          "sum":"",
          "dw":"",
          "sum1":"15",
          "dw1":"%",
          "img":require('@/assets/Energy_saving.png'),
          "bj":"data_5"
        },
        {
          "text":"减少碳排放",
          "sum":"",
          "dw":"",
          "sum1":"15",
          "dw1":"Kg",
          "img":require('@/assets/carbon_emission.png'),
          "bj":"data_5"
        }
      ],
      xz_date:""
    };
  },
  methods:{ /*方法存放*/
    upDate() { /*更新时间*/
      this.item_xz = -1;
      console.log(this.formatDateTime(this.xz_date[0],'day'));
      console.log(this.formatDateTime(this.xz_date[1],'day'));
      this.loading = this.$load.service({spinner:"",text:"正在加载中...",background:"rgba(0, 0, 0, 0.3)"});
      let date1 = this.formatDateTime(this.xz_date[0],'day');
      let date2 = this.formatDateTime(this.xz_date[1],'day');
      this.nh_mDate = this.getAllDate(date1,date2);
      this.loading.close();
      console.log(this.nh_mDate);
      this.drawLine();
    },
    onRq(itm) {
      this.item_xz = itm;
      if (itm === 0) {
        this.xz_time = moment().subtract(1,'day').format('YYYY-MM-DD');
        let d = new Date(this.xz_time);
        this.nh_mDate = this.getToDay(); /*获取当前小时*/
        this.all_yDate = []; /*获取月份*/
        for (var i = 0; i < 25; i++) { /*2024-01-01 00:00:00*/
          this.all_yDate.push(`${d.getFullYear()}-${this.pad(i)}-${this.pad(1)}`);
        }
        this.getToday();
      } else if (itm === 1) {
        this.xz_time = moment().subtract(1,'day').format('YYYY-MM-DD');
        let d = new Date(this.xz_time);
        this.nh_mDate = this.getDay(7);
        // this.all_yDate = [] /*获取周*/
        // for (var i = 1; i < d.getMonth() + 1; i++) { /*2024-01-01 00:00:00*/
        //   this.all_yDate.push(`${d.getFullYear()}-${this.pad(i)}-${this.pad(1)} 00:00:00`)
        // }
        this.getWeek();
      } else if (itm === 2) {
        this.xz_time = moment().subtract(1,'day').format('YYYY-MM-DD');
        let d = new Date(this.xz_time);
        this.nh_mDate = this.getDay(this.getMonthDay(d.getFullYear(),d.getMonth() + 1));
        // this.all_yDate = [] /*获取月份*/
        // for (var i = 1; i < d.getMonth() + 1; i++) { /*2024-01-01 00:00:00*/
        //   this.all_yDate.push(`${d.getFullYear()}-${this.pad(i)}-${this.pad(1)} 00:00:00`)
        // }
        this.getCurMonth();
      } else {
        this.xz_time = moment().subtract(1,'day').format('YYYY-MM-DD');
        let d = new Date(this.xz_time);
        this.nh_mDate = this.getMon();
        this.all_yDate = []; /*获取月份*/
        for (var i = 1; i < d.getMonth() + 1; i++) { /*2024-01-01 00:00:00*/
          this.all_yDate.push(`${d.getFullYear()}-${this.pad(i)}-${this.pad(1)} 00:00:00`);
        }
        this.getCurYear();
      }
      this.xz_date = "";
      this.drawLine();
    },
    pad(num) {
      return num.toString().padStart(2,'0');
    },
    getToDay() {
      let li = [];
      for (var i = 18; i < 25; i++) {
        li.push(this.pad(i));
      }
      return li;
    },
    getDay(v) {
      let li = [];
      for (var i = 1; i < v + 1; i++) {
        li.push(i);
      }
      return li;
    },
    getMon() {
      let li = [];
      for (var i = 1; i < 13; i++) {
        li.push(i);
      }
      return li;
    },
    getAllDate(start,end) { /*获取两个时间中间所有时间*/
      var dateList = [];
      var startTime = Date.parse(new Date(start));
      var endTime = Date.parse(new Date(end));
      var days = Math.ceil((endTime - startTime) / (1000 * 60 * 60 * 24));
      for (var i = 0; i < days + 1; i++) {
        var tempDate = new Date(startTime + i * 24 * 60 * 60 * 1000);
        dateList.push(this.formatDateTime(tempDate,'allDate'));
      }
      // for (var i = 0; i < days; i++) {
      //   var tempDate = new Date(startTime + i * 24 * 60 * 60 * 1000);
      //   dateList.push({
      //     "key": this.formatDateTime(tempDate, 'allDate'),
      //     "val": this.formatDateTime(tempDate, 'day') + " 00:00:00",
      //     "g": this.formatDateTime(tempDate, 'allDate') + "时长(高)",
      //     "z": this.formatDateTime(tempDate, 'allDate') + "时长(中)",
      //     "d": this.formatDateTime(tempDate, 'allDate') + "时长(低)",
      //     "df": this.formatDateTime(tempDate, 'allDate') + "电费",
      //   });
      // }
      // dateList.push({ /*添加结束日期*/
      //   "key": this.formatDateTime(new Date(end), 'allDate'),
      //   "val": this.formatDateTime(new Date(end), 'day') + " 00:00:00",
      //   "g": this.formatDateTime(new Date(end), 'allDate') + "时长(高)",
      //   "z": this.formatDateTime(new Date(end), 'allDate') + "时长(中)",
      //   "d": this.formatDateTime(new Date(end), 'allDate') + "时长(低)",
      //   "df": this.formatDateTime(new Date(end), 'allDate') + "电费",
      // });
      return dateList;
    },
    formatDateTime(date,name) { /*时间解析*/
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();
      let data = "";
      switch (name) {
        case "allDate":
          data = `${this.pad(month)}/${this.pad(day)}`;
          break;
        case "day":
          data = `${year}-${this.pad(month)}-${this.pad(day)}`;
          break;
      }
      return data;
    },
    getYesterday() { /*获取昨天时间*/
      return [
        new Date(moment().subtract(1,'day').format('YYYY-MM-DD')),
        new Date(moment().subtract(0,'day').format('YYYY-MM-DD'))
      ];
    },
    getMonthDay(year,month) { /*获取一个月有多少天*/
      return new Date(year,month,0).getDate();
    },
    drawLine() {
      let myChart = this.$echarts.getInstanceByDom(
          document.getElementById('myChart')
      );
      if (myChart == null) {  /*基于准备好的dom，初始化echarts实例*/
        this.myChart = this.$echarts.init(document.getElementById('myChart'));
      }
      this.myChart.setOption({ /*绘制图表*/
        title:{
          text:'', // 主标题
          subtext:'', // 副标题
          x:'left', // x轴方向对齐方式
          padding:[
            0,
            0,
            0,
            0
          ], /*上 右 下 左*/
          textStyle:{ /*图例文字的样式*/
            color:'#000',
            fontSize:16
          }
        },
        tooltip:{
          trigger:'axis' // axis   item   none三个值
        },
        color:[
          '#4472C5',
          '#ED7C30',
          '#80FF80',
          '#FF8096',
          '#800080'
        ],
        legend:{
          orient:'horizontal', /*vertical*/
          x:'center',
          y:'top',
          padding:[
            20,
            0,
            0,
            0
          ], /*上 右 下 左*/
          data:[
            '改造前',
            '实际消耗'
          ],
          textStyle:{ /*图例文字的样式*/
            color:'#000',
            fontSize:16
          }
        },
        grid:{
          left:'2%',
          right:'2%',
          bottom:'2%',
          containLabel:true
        },
        xAxis:{
          type:'category', // 还有其他的type，可以去官网喵两眼哦
          data:this.nh_mDate, // x轴数据
          name:'',  /*x轴名称*/
          show:true,
          axisLabel:{
            color:'#000',
            fontSize:14
          }
        },
        yAxis:{
          type:'value',
          name:'',  /*y轴名称*/
          axisLabel:{
            color:'#000',
            fontSize:14
          }
        },
        series:[
          {
            name:'改造前',
            data:this.nh_save,
            type:'bar',  /*bar柱状图 line折线图*/
            itemStyle:{
              color:'#4472C5'
            },
            areaStyle:{
              color:'#4472C5' // 底部填充颜色
            },
            tooltip:{
              valueFormatter:function (value) {
                return value + ' 瓦';
              }
            }
          },
          {
            name:'实际消耗',
            data:this.nh_consume,
            type:'bar',
            itemStyle:{
              color:'#ED7C30'
            },
            tooltip:{
              valueFormatter:function (value) {
                return value + ' 瓦';
              }
            }
          }
        ]
      });
    },
    init_view() {
      this.xz_time = moment().subtract(1,'day').format('YYYY-MM-DD');
      let d = new Date(this.xz_time);
      this.nh_mDate = this.getToDay(); /*获取当前小时*/
      this.getToday();
      this.drawLine();
      // this.all_yDate = [] /*获取月份*/
      // for (var i = 0; i < 25; i++) { /*2024-01-01 00:00:00*/
      //   this.all_yDate.push(`${d.getFullYear()}-${this.pad(i)}-${this.pad(1)} 00:00`)
      // }
    },
    getCurYear() {  /*获取年数据*/
      const params = {
        "projectId":"saas_school_20230531"
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.curYear,params,headers).then(res => {
        let data = res.data.data;
        console.log("获取年统计日志",data);
        this.loading.close();
        this.li_right[0]["sum"] = data["consume"];
        this.li_right[0]["sum1"] = data["consumeMoney"];
        this.li_right[1]["sum"] = data["save"];
        this.li_right[1]["sum1"] = data["saveMoney"];
        this.li_right[2]["sum1"] = data["rate"];
        this.li_right[3]["sum1"] = data["decreaseCo2"];
        let l_d = data["energy"];
        let data_save = []; /*节省*/
        let data_consume = []; /*实际*/
        for (let i = 0; i < this.nh_mDate.length; i++) {
          if (l_d && l_d.length > 0) {
            let d = l_d.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
              return parseInt(fruit['month']) === parseInt(this.nh_mDate[i]);
            });
            if (d !== undefined) {
              data_consume.push(d["consume"]);
              data_save.push(parseInt(d["consume"]) + parseInt(d["save"]));
            } else {
              data_save.push(0);
              data_consume.push(0);
            }
          }
        }
        this.nh_consume = data_consume;
        this.nh_save = data_save;
        this.drawLine();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取数据失败");
        }
      });
    },
    getCurMonth() { /*获取月数据*/
      const params = {
        "projectId":"saas_school_20230531"
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.curMonth,params,headers).then(res => {
        let data = res.data.data;
        console.log("获取月时间",this.nh_mDate);
        console.log("获取月统计日志",data);
        this.loading.close();
        this.li_right[0]["sum"] = data["consume"];
        this.li_right[0]["sum1"] = data["consumeMoney"];
        this.li_right[1]["sum"] = data["save"];
        this.li_right[1]["sum1"] = data["saveMoney"];
        this.li_right[2]["sum1"] = data["rate"];
        this.li_right[3]["sum1"] = data["decreaseCo2"];
        let l_d = data["energy"];
        let data_save = []; /*节省*/
        let data_consume = []; /*实际*/
        for (let i = 0; i < this.nh_mDate.length; i++) {
          if (l_d && l_d.length > 0) {
            let d = l_d.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
              return parseInt(fruit['date']) === parseInt(this.nh_mDate[i]);
            });
            if (d !== undefined) {
              data_consume.push(d["consume"]);
              data_save.push(parseInt(d["consume"]) + parseInt(d["save"]));
            } else {
              data_save.push(0);
              data_consume.push(0);
            }
          }
        }
        this.nh_consume = data_consume;
        this.nh_save = data_save;
        this.drawLine();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取数据失败");
        }
      });
    },
    getWeek() { /*获取月数据*/
      const params = {
        "projectId":"saas_school_20230531"
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.curWeek,params,headers).then(res => {
        let data = res.data.data;
        console.log("获取周时间",this.nh_mDate);
        console.log("获取周统计日志",data);
        this.loading.close();
        this.li_right[0]["sum"] = data["consume"];
        this.li_right[0]["sum1"] = data["consumeMoney"];
        this.li_right[1]["sum"] = data["save"];
        this.li_right[1]["sum1"] = data["saveMoney"];
        this.li_right[2]["sum1"] = data["rate"];
        this.li_right[3]["sum1"] = data["decreaseCo2"];
        let l_d = data["energy"];
        let data_save = []; /*节省*/
        let data_consume = []; /*实际*/
        for (let i = 0; i < this.nh_mDate.length; i++) {
          if (l_d && l_d.length > 0) {
            let d = l_d.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
              return parseInt(fruit['day']) === parseInt(this.nh_mDate[i]);
            });
            if (d !== undefined) {
              data_consume.push(d["consume"]);
              data_save.push(parseInt(d["consume"]) + parseInt(d["save"]));
            } else {
              data_save.push(0);
              data_consume.push(0);
            }
          }
        }
        this.nh_consume = data_consume;
        this.nh_save = data_save;
        this.drawLine();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取数据失败");
        }
      });
    },
    getToday() { /*获取日数据*/
      const params = {
        "projectId":"saas_school_20230531"
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.today,params,headers).then(res => {
        let data = res.data.data;
        console.log("获取日统计日志",data);
        this.loading.close();
        this.li_right[0]["sum"] = data["consume"];
        this.li_right[0]["sum1"] = data["consumeMoney"];
        this.li_right[1]["sum"] = data["save"];
        this.li_right[1]["sum1"] = data["saveMoney"];
        this.li_right[2]["sum1"] = data["rate"];
        this.li_right[3]["sum1"] = data["decreaseCo2"];
        let l_d = data["energy"];
        let data_save = []; /*节省*/
        let data_consume = []; /*实际*/
        for (let i = 0; i < this.nh_mDate.length; i++) {
          if (l_d && l_d.length > 0) {
            let d = l_d.find((fruit) => { /*js快速查找数组--筛选当前tree列表*/
              return parseInt(fruit['hour']) === parseInt(this.nh_mDate[i]);
            });
            if (d !== undefined) {
              data_consume.push(d["consume"]);
              data_save.push(parseInt(d["consume"]) + parseInt(d["save"]));
            } else {
              data_save.push(0);
              data_consume.push(0);
            }
          }
        }
        this.nh_consume = data_consume;
        this.nh_save = data_save;
        this.drawLine();
      }).catch(error => {
        console.log(error);
        this.loading.close();
        if (error) {
          this.$message.error("获取数据失败");
        }
      });
    }
  },
  mounted() { /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    this.loading = this.$load.service({spinner:"",text:"正在加载中...",background:"rgba(0, 0, 0, 0.3)"});
    this.init_view();
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#data {
  height: 100vh;
  margin: 0;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #F4F4F4;
  height: auto;
  padding: 0;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}

.data_active {
  color: #134FC2;
}

.div_left {
  background: #F4F4F4;
}
</style>



// WEBPACK FOOTER //
// src/components/data.vue